// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { SurveyUserDetailsModel, UpdateStatuses } from '../../../models';
import { AppService } from '../app.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class UserDetailsBaseService {

  protected _userDetails$: BehaviorSubject<SurveyUserDetailsModel | null>;
  get userDetails$(): Observable<SurveyUserDetailsModel | null> {
    return this._userDetails$.asObservable();
  }

  protected _latestUpdateStatus$: BehaviorSubject<UpdateStatuses>;
  get latestUpdateStatus$(): Observable<UpdateStatuses> {
    return this._latestUpdateStatus$.asObservable();
  }

  protected _isLoaded: boolean = false;

  constructor(protected appService: AppService,) {
    this._userDetails$ = new BehaviorSubject<SurveyUserDetailsModel | null>(null);
    this._latestUpdateStatus$ = new BehaviorSubject<UpdateStatuses>(UpdateStatuses.notStarted);
  }
  abstract loadSurveyUserDetails(): void;
  abstract updateUserDetails(userDetails: SurveyUserDetailsModel): void;
}
